// URL 一次性代碼檢查和處理（SSO 跳轉）
import { setCrossDomainCookie, buildApiUrl, cleanUrlParams } from '@redpanda/utils';
/**
 * 同一個一次性代碼只換一次：代碼只能用一次，React 開發模式（StrictMode）會把初始化跑兩次，
 * 第二次再換就會失敗；同一頁面內共用第一次的結果
 */
const exchanges = new Map();
/**
 * 檢查並處理 URL 中的 auth_code（SSO 跳轉帶來的一次性代碼，2 分鐘、只能用一次）
 * 向 identity 換回 token，存進自己網域的 cookie（各瀏覽器都驗證過可行的做法），清掉網址上的代碼
 * @param identityServiceUrl Identity Service 的 URL
 * @param productionDomain 生產環境的域名 (例如: '.redpanda-tech.com')
 * @returns 認證結果
 */
export async function checkUrlToken(identityServiceUrl, productionDomain) {
    const authCode = new URLSearchParams(window.location.search).get('auth_code');
    if (!authCode) {
        return { authenticated: false };
    }
    let pending = exchanges.get(authCode);
    if (!pending) {
        pending = fetch(buildApiUrl(identityServiceUrl, '/auth/code/exchange'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: authCode }),
        })
            .then(response => response.json())
            .then((data) => {
            cleanUrlParams(['auth_code']);
            if (data.valid && data.user && data.token) {
                setCrossDomainCookie('auth_token', data.token, productionDomain);
                return { authenticated: true, user: data.user };
            }
            return { authenticated: false };
        })
            .catch(error => {
            console.error('SSO code exchange failed:', error);
            return { authenticated: false };
        });
        exchanges.set(authCode, pending);
    }
    return pending;
}
